enum MenuTag {
  customization = 'Personalização',
  others = 'Outros',
}

export default MenuTag;
